import React, { useCallback, useState } from "react";
import { AnnouncementStyled } from "./styled/AnnouncementStyled.js";
import { useSelector } from "react-redux";
import { getAppAnnouncement } from "../../app/appSelectors";
import BinIcon from "../icon/Icon";
import Cookies from "universal-cookie";

const browserCookies = new Cookies();

function Announcement() {
    const announcementText = useSelector(getAppAnnouncement);
    const [hide, setHide] = useState(browserCookies.get('announcement_hide'));

    const onCloseHandler = useCallback((e) => {
        e.preventDefault();
        browserCookies.set('announcement_hide', true, { path: '/', maxAge: 60 * 60 * 24 });
        setHide(true);
    }, []);

    if (!announcementText || hide) {
        return null;
    }

    return <AnnouncementStyled>
        <div dangerouslySetInnerHTML={{ __html: announcementText }}/>
        <div onClick={onCloseHandler} className={'mx-2'}><BinIcon name={'IcClose'}
                                                                  style={{ fill: 'white' }}/></div>
    </AnnouncementStyled>
}

export default Announcement;
